module.exports = __webpack_public_path__ + "static/media/hiw-icon-cardetails.ab785989.webp";